module.exports = __webpack_public_path__ + "337e9638491e2fbf2610aec71f8237a5.mp3";